module.exports = __webpack_public_path__ + "static/media/d19ru.5460f72e.pdf";